import r from "clsx";
import e from "react";

var m = function m() {
  return e.createElement("li", {
    className: r("hg-primarynav__item", "hg-primarynav__item--skeleton")
  }, e.createElement("div", {
    className: "skeleton-content"
  }));
};

export { m as SkeletonLoader };